<template>
  <div class="communityadmin-banner">
    <img :src="communityadminBanner" alt="" />
    <div class="absolute">
      <div class="title">社区管理</div>
      <div class="text">
        随着人工智能技术、物联网技术等技术的发展趋势，打造数字安防监控系统、智能门禁、智能车辆道闸系统、人脸识别、车牌识别、智能安防管理系统、智慧物业、智慧养老管理系统等智能集成系统。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import communityadminBanner from "../../../../assets/programme/communityadminBanner.png";

export default {
  setup() {
    return reactive({
      communityadminBanner: communityadminBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.communityadmin-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .communityadmin-banner {
    min-width: 1180px;
  }
}
.communityadmin-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 20px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
